import React, { useState, useEffect } from "react";


import BackArrow from './partials/BackArrow.jsx'
import { InlineWidget } from "react-calendly";

export default function About(props) {
  return (
    <div style={styles.container}>
      <div
        style={styles.videoWrapper}
      >
        <iframe
        src="https://player.vimeo.com/video/1181968854?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479"
          title="Promo Video"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          style={styles.iframe}
        />
      </div>

      {/* “I’ve finished” button disabled until timer completes */}
<div
                style={{
                    width: "100%",
                    maxWidth: "800px",
                    margin: "50px auto",
                    textAlign: "center",
                }}
                >
 
  
                <div
                    style={{
                    marginTop: "40px",
                    }}
                >
                    <div style={{ height: "700px" }}>
                    <InlineWidget url="https://calendly.com/cataractpreop/30min?hide_event_type_details=1&hide_landing_page_details=1" />
                    </div>
                </div>
    </div>
    </div>
  );

  
};

const styles = {
  container: {
    maxWidth: "620px",
    margin: "auto",
    padding: "40px",
    textAlign: "center",
    fontFamily: "system-ui",
    zIndex: '100',
  },
  videoWrapper: {
    position: "relative",
    width: "100%",
    paddingTop: "56.25%", // 16:9
    marginBottom: "30px"
  },
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "12px",
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, .2), 0 3px 10px 0 rgba(0, 0, 0, .15)',
  }
};
